import GameObject from '../../GameObject/GameObject';
import { ConcatIterators, PlayAnimation, StartAnimationClip } from '../../System/Animation/AnimationHelper';
import { delay } from '../../Utility/Task/TaskQueue';
import Armature from 'Prototype/Armature';
import { DragonbonesDefault, DragonbonesFadeIn } from 'System/Animation/Clip';
import Renderable from 'Component/Renderable';

export class FarmLoadingScreen extends GameObject {
    public cloudArmature: Armature;
    public iconArmature: Armature;

    protected onCreate(params: any): void {
        this.cloudArmature = GameObject.Instantiate(Armature, {
            name: 'cloudArmature',
            dragonbonesName: 'my_farm_loading',
            armatureName: 'clouds',
            animationName: 'clouds_disappear',
            playOnStart: false,
            alpha: 0,
        });
        this.addChild(this.cloudArmature);
        this.iconArmature = GameObject.Instantiate(Armature, {
            name: 'iconArmature',
            dragonbonesName: 'my_farm_loading',
            armatureName: 'loader',
            animationName: 'animation',
            playOnStart: true,
        });
        this.addChild(this.iconArmature);
    }

    public *animate(): IterableIterator<number> {
        yield* ConcatIterators([
            PlayAnimation(
                new DragonbonesFadeIn(this.cloudArmature, {
                    playTimes: 1,
                    fadeInTime: 200,
                    animationName: 'clouds_appear',
                    concat: false,
                })
            ),
            PlayAnimation(
                new DragonbonesDefault(this.cloudArmature, {
                    animationName: 'clouds_idle'
                })
            )
        ])
    }

    public stopAnimation() {
        StartAnimationClip(
            new DragonbonesDefault(this.cloudArmature, {
                animationName: 'clouds_disappear'
            })
        );
    }
}
